// Maps backend/network error text to plain-language messages safe to show
// end users. Backend errors can contain raw exception text, model IDs, or
// storage URLs (e.g. "OSError: Can't load the model for 'facebook/nllb...'")
// — never render err.message / err.detail directly in the UI.

const ERROR_PATTERNS = [
  [/network error|failed to fetch|load failed/i,
    'Could not reach the server. Check your internet connection and try again.'],
  [/s3 upload failed|upload failed/i,
    'The upload did not go through. Please try again.'],
  [/huggingface\.co|\.safetensors|\.bin\b|torch|OSError|nllb|madlad|towerinstruct/i,
    'The transcription/translation service hit a temporary problem on our end. Please try again in a few minutes.'],
  [/http 401|unauthorized/i,
    'Your session has expired. Please sign in again.'],
  [/http 403|forbidden|no access/i,
    'You don’t have permission to do that. Contact your administrator if this seems wrong.'],
  [/http 404|not found/i,
    'We couldn’t find that item. It may have been deleted.'],
  [/http 5\d\d/i,
    'Something went wrong on our end. Please try again in a few minutes.'],
  [/unexpected token|json/i,
    'The server sent back something we didn’t expect. Please try again.'],
];

const FALLBACKS = {
  upload: 'Something went wrong while uploading. Please try again.',
  transcription: 'Something went wrong while transcribing. Please try again.',
  translation: 'Something went wrong while translating. Please try again.',
  save: 'Your changes could not be saved. Please try again.',
  admin: 'That action did not complete. Please try again.',
  default: 'Something went wrong. Please try again.',
};

export function toUserMessage(err, context = 'default') {
  const raw = typeof err === 'string' ? err : (err?.detail || err?.message || String(err ?? ''));
  if (raw) {
    console.error(`[${context}]`, raw);
  }
  for (const [pattern, message] of ERROR_PATTERNS) {
    if (pattern.test(raw)) return message;
  }
  return FALLBACKS[context] || FALLBACKS.default;
}
